// ** Third Party Imports
import * as yup from 'yup'

// ** Utility Imports
import { EMAIL } from '@/shared/lib'

export const schema = yup.object().shape({
	firstName: yup.string().required('This field is required.'),
	lastName: yup.string().required('This field is required.'),
	companyName: yup.string().required('This field is required.'),
	email: yup
		.string()
		.matches(EMAIL, 'Email must be a valid email.')
		.required('Email is a required field.'),
	message: yup.string().required('Message is a required field.')
})
